"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileApproveEscapeIntent = exports.ActionEvent = void 0;
require("../vendor/com.ts.mobile.sdk");
var ActionEvent;
(function (ActionEvent) {
    ActionEvent["account_opening"] = "account_opening";
    ActionEvent["invest_ola"] = "invest_ola";
    ActionEvent["transaction_wire"] = "transaction_wire";
    ActionEvent["login"] = "login";
    ActionEvent["online_enrollment"] = "online_enrollment";
    ActionEvent["forgot_password"] = "forgot_password";
    ActionEvent["forgot_username"] = "forgot_username";
})(ActionEvent = exports.ActionEvent || (exports.ActionEvent = {}));
var MobileApproveEscapeIntent;
(function (MobileApproveEscapeIntent) {
    MobileApproveEscapeIntent["Repick"] = "repick";
    MobileApproveEscapeIntent["Resend"] = "resend";
    MobileApproveEscapeIntent["Timeout"] = "timeout";
})(MobileApproveEscapeIntent = exports.MobileApproveEscapeIntent || (exports.MobileApproveEscapeIntent = {}));
//# sourceMappingURL=types.js.map